import React from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import {
  hasCorePlatformEnabled,
  isHotelScopedSubscriptionRole,
} from "@/utils/accessControl";

interface CorePlatformGuardProps {
  children: React.ReactNode;
  fallbackPath?: string;
}

export const CorePlatformGuard: React.FC<CorePlatformGuardProps> = ({
  children,
  fallbackPath = "/account",
}) => {
  const { t } = useTranslation();
  const { isLoading, userProfile } = useAuthenticatedUser();

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="text-muted-foreground">{t("common.loading")}</div>
      </div>
    );
  }

  if (
    isHotelScopedSubscriptionRole(userProfile) &&
    !hasCorePlatformEnabled(userProfile)
  ) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};
